export default __webpack_public_path__ + "static/media/register.ca3a2b1c.jpg";